import { forwardRef } from 'react';
import { cn } from 'lib/utils';
import { treezDashboardUrl } from 'utils/urlGenerator';
import { ENV } from 'utils/config';
import TreezLogo from 'assets/img/store/logo.svg';
import { NavItemLabel } from './nav-item-label';
import type { SidebarFooterProps } from './types';

const SidebarFooter = forwardRef<HTMLDivElement, SidebarFooterProps>(
  ({ isCollapsed = false, className }, ref) => {
    const env = ENV || 'production';
    const dashboardUrl = treezDashboardUrl(env);

    return (
      <div ref={ref} className={cn('pt-2', className)}>
        <a
          href={dashboardUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={cn(
            'group flex items-center rounded-md px-4 py-2',
            'text-sm font-normal leading-5 text-gray-blue-80',
            'transition-colors duration-150',
            'hover:bg-gray-blue-5 hover:text-gray-blue-90',
            'focus:outline-none focus-visible:ring-2 focus-visible:ring-green-400 focus-visible:ring-offset-2',
            isCollapsed && 'justify-center'
          )}
          aria-label="Open Treez Dashboard in new tab"
        >
          <img
            src={TreezLogo}
            alt=""
            className="h-5 w-5 shrink-0"
            aria-hidden="true"
          />

          <NavItemLabel isCollapsed={isCollapsed}>Dashboard</NavItemLabel>
        </a>
      </div>
    );
  }
);

SidebarFooter.displayName = 'SidebarFooter';

export { SidebarFooter };
